import DesignButton from 'components/button/DesignButton';
import { useAuth, withAuthenticationRequired } from 'react-oidc-context';

const Logout = () => {
  const auth = useAuth();
  return (
    <div className="flex h-screen items-center justify-center bg-design-black">
      <div className="flex h-3/6 w-3/6 flex-col items-center">
        <h5 className="my-3 uppercase text-white">
          Are you sure you want to sign out?
        </h5>
        <div className="w-1/6">
          <DesignButton
            onClickHandler={async () => {
              await auth.signoutRedirect();
              await auth.removeUser();
            }}
            className="text-white"
          >
            Sign out
          </DesignButton>
        </div>
      </div>
    </div>
  );
};

export default withAuthenticationRequired(Logout);
